import { NavigationLink } from "../NavigationLink";

import { MENU_STYLES } from "./constants";
import { MenuItemProps } from "./types";

import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip";

export const SimpleMenuItem = ({ item, isActive, isCollapsed }: MenuItemProps) => {
  const Icon = item.icon;

  const menuButton = (
    <SidebarMenuButton
      isActive={isActive}
      className={`${MENU_STYLES.menuButton.base} ${
        isCollapsed ? MENU_STYLES.menuButton.collapsed : MENU_STYLES.menuButton.expanded
      }`}
    >
      <span className="relative inline-flex">
        <Icon className={`${MENU_STYLES.icon.main} ${MENU_STYLES.icon.base}`} />
        {item.showUnreadIndicator && (
          <span className="absolute -right-0.5 -top-0.5 size-2 rounded-full border border-white bg-blue-600" />
        )}
      </span>
      {!isCollapsed && (
        <>
          <span className="font-medium">{item.name}</span>
          {item.badgeLabel && (
            <span className="ml-auto rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-semibold tracking-wide text-blue-700">
              {item.badgeLabel}
            </span>
          )}
        </>
      )}
    </SidebarMenuButton>
  );

  const wrapper = item.onClick ? (
    <button type="button" onClick={item.onClick} className="w-full text-left">
      {menuButton}
    </button>
  ) : (
    <NavigationLink to={item.href!}>{menuButton}</NavigationLink>
  );

  if (isCollapsed) {
    return (
      <SidebarMenuItem>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="relative">
              {item.onClick ? (
                <button type="button" onClick={item.onClick} className="w-full">
                  {menuButton}
                </button>
              ) : (
                <NavigationLink to={item.href!}>{menuButton}</NavigationLink>
              )}
            </div>
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>{item.name}</p>
          </TooltipContent>
        </Tooltip>
      </SidebarMenuItem>
    );
  }

  return <SidebarMenuItem>{wrapper}</SidebarMenuItem>;
};
